import { render } from "./DeleteInstanceDialog.vue?vue&type=template&id=d9c0cd8e&ts=true"
import script from "./DeleteInstanceDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteInstanceDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__